import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import type { UntypedFormGroup } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import type { Observable } from 'rxjs';

import type { DeviceMode } from '@common/types/layout.type';
import { ThemeStateService } from '@sites/site-theme/src/state';
import { ThemeSettings } from '@sites/site-theme/src/enums/theme-settings.enum';
import { SpThemesComponent } from '@sites/site-theme/src/components/themes.component';
import { LayoutFacade } from '@web/store/layout/layout.facade';

import { AbstractBaseSettingsComponent } from '../abstract-base-settings/abstract-base-settings.component';
import { SettingsBodyComponent } from '../settings-body/settings-body.component';
import { SettingsBreadcrumbsComponent } from '../settings-breadcrumbs/settings-breadcrumbs.component';

@Component({
    selector: 'web-theme-settings',
    templateUrl: './theme-settings.component.html',
    styleUrls: ['./theme-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SettingsBodyComponent, SettingsBreadcrumbsComponent, SpThemesComponent, AsyncPipe, TranslateModule],
})
export class ThemeSettingsComponent extends AbstractBaseSettingsComponent {
    protected readonly themeState = inject(ThemeStateService);
    protected readonly layoutFacade: LayoutFacade = inject(LayoutFacade);

    public themeSettingsForm: UntypedFormGroup;

    public readonly deviceMode$: Observable<DeviceMode> = this.layoutFacade.deviceMode$;

    public readonly activeThemeSetting = this.themeState.activeSetting;

    public readonly activeThemeLabel: Record<ThemeSettings, string> = {
        [ThemeSettings.buttonsSettings]: 'theme_settings_buttons_customization',
        [ThemeSettings.colorsSettings]: 'theme_settings_color_palette_customization',
        [ThemeSettings.fontsSettings]: 'theme_settings_font_customization',
    };

    public unselectActiveTheme(): void {
        this.themeState.unselectActiveSetting();
    }

    protected initForm(): void {
        this.themeSettingsForm = this.fb.group({});
    }

    public changeDeviceMode(deviceMode: DeviceMode): void {
        this.layoutFacade.changeDeviceMode(deviceMode);
    }
}
